import { Component, Inject } from "@angular/core";
import { FormArray, FormControl, FormGroup, UntypedFormArray } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'kt-review-process',
  templateUrl: './review-process-modal.component.html'
})
export class ReviewProcessModal {
  private _map: number[] = []

  formArray = new FormArray<FormGroup<{
    status: FormControl<boolean>,
    text: FormControl<string>
  }>>([])

  constructor(
    private dialogRef: MatDialogRef<ReviewProcessModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this._patchFormArray(
      data.notes.length == 0
        ? [{id: null, status: false, text: null}]
        : data.notes
    )

    if (!data.isReviewer) {
      this.formArray.controls.forEach(group => {
        group.controls.text.disable()
      })
    } else {
      this.formArray.controls.forEach(group => {
        group.controls.text.enable()
      })
    }
  }

  onClose() {
    this.dialogRef.close()
  }

  onSave() {
    let vals = []
    this.formArray.controls.forEach((group, i) => {
      const _new = {id: null, status: false, text: null}
      if (this._map[i]) {
        _new.id = this._map[i];
      }
      _new.status = group.controls.status.value 
      _new.text = group.controls.text.value
      vals.push(_new)
    })
    this.dialogRef.close({
      data: vals
    })
  }

  onAddNote() {
    const group = new FormGroup({
      status: new FormControl<boolean>(false),
      text: new FormControl<string>(null)
    })
    this.formArray.push(group);
    this._map.push(null)
  }
  onRemoveNote(index: number) {
    this.formArray.removeAt(index)
  }

  private _patchFormArray(items: {id: number, status: boolean, text: string}[]) {
    items.forEach(item => {
      this.formArray.push(new FormGroup({
        status: new FormControl<boolean>(item.status),
        text: new FormControl<string>(item.text)
      }))
      this._map.push(item.id)
    })
  }
}